import {
  Map,
} from 'immutable';
import {
  PURGE,
} from 'redux-persist';

import {
  RESET,
  SET_SELECTED_MENU_ITEM,
  SET_SELECTED_ELEMENT,
  SET_SELECTED_CONTENT_TYPE,
  SET_READ_ONLY_ELEMENT,
  SET_EXPIRATION_DATE,
} from './actionTypes';
import { AUTHORIZED_CONTENT_TYPE_FOMRS, MENU_ITEM__FORMS__ASSIGNED } from './constants';

const initialState = Map({
  // Wybrany element menu.
  selectedMenuItem: MENU_ITEM__FORMS__ASSIGNED,
  // Wybrany element (ankieta lub formularz).
  selectedElement: null,
  // Wybrany kontent strony
  selectedContentType: AUTHORIZED_CONTENT_TYPE_FOMRS,
  // Wygaśnięcie sesji
  expirationDate: null,
});

export default (state = initialState, action) => {
  switch (action.type) {
    case PURGE:
      return initialState;

    case RESET:
      return initialState;

    case SET_SELECTED_MENU_ITEM:
      return state
        .set('selectedMenuItem', action.payload);

    case SET_SELECTED_ELEMENT:
      return state
        .set('selectedElement', action.payload);

    case SET_SELECTED_CONTENT_TYPE:
      return state
        .set('selectedContentType', action.payload);

    case SET_READ_ONLY_ELEMENT:
      return state
        .set('readOnlyElement', action.payload);

    case SET_EXPIRATION_DATE:
      return state
        .set('expirationDate', action.payload);
    default:
      return state;
  }
};
